var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-input-item',_vm._g(_vm._b({staticClass:"input-phone-number",attrs:{"placeholder":_vm.$t('inputPhoneNum'),"maxlength":_vm.maxlength}},'md-input-item',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }